import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@mui/material';

import { PaymentInstrumentIcon } from '@ocx-app/components/payment-instrument-icon';
import { ListSelector } from '@ocx-app/hooks/useListController';
import { PaymentMethodSelectorPopup, usePaymentMethodSelectorPopup } from '@ocx-app/components/modals';

import { Typography } from '@ocx/ui';
import { PaymentInstrument, getPaymentInstrumentListItemInfo } from '@ocx/data-payment-instruments';

import { messages } from '../../../pay-at-pump.messages';
import { PaymentMethodButton } from './payment-method.button';

type SelectPaymentMethodProps = {
  paymentInstrumentsListSelector: ListSelector<PaymentInstrument>;
  onAddPaymentMethodClick: () => void;
};

export const PaymentMethodSelector = (props: SelectPaymentMethodProps) => {
  const paymentMethodSelectorPopup = usePaymentMethodSelectorPopup();
  const { paymentInstrumentsListSelector, onAddPaymentMethodClick } = props;
  const { selectedListItem, listItems } = paymentInstrumentsListSelector;

  const paymentMethodButton = useMemo(() => {
    if (!selectedListItem) {
      return (
        <PaymentMethodButton onClick={paymentMethodSelectorPopup.show}>
          <FormattedMessage {...messages.choosePaymentMethod} />
        </PaymentMethodButton>
      );
    }
    const { hiddenCardNumber, displayName, formattedBalance } = getPaymentInstrumentListItemInfo(selectedListItem);

    return (
      <Box>
        <PaymentMethodButton
          onClick={paymentMethodSelectorPopup.show}
          startIcon={
            selectedListItem.paymentType ? <PaymentInstrumentIcon type={selectedListItem.paymentType} /> : undefined
          }
          balance={formattedBalance}
          isExpired={selectedListItem.isExpired}
          hiddenCardNumber={hiddenCardNumber}
          withEndArrow>
          {displayName}
        </PaymentMethodButton>
        {selectedListItem.isExpired && (
          <Typography fontSize="small" color="error" marginTop={1}>
            <FormattedMessage {...messages.chooseAnotherPaymentMethod} />
          </Typography>
        )}
      </Box>
    );
  }, [paymentMethodSelectorPopup.show, selectedListItem]);

  if (!listItems.length) {
    return (
      <PaymentMethodButton onClick={onAddPaymentMethodClick}>
        <FormattedMessage {...messages.payAtPumpAddPaymentInstrumentButtonTitle} />
      </PaymentMethodButton>
    );
  }

  return (
    <>
      {paymentMethodButton}
      <PaymentMethodSelectorPopup
        paymentInstrumentsListSelector={paymentInstrumentsListSelector}
        onAddPaymentMethodClick={onAddPaymentMethodClick}
        id={paymentMethodSelectorPopup.id}
      />
    </>
  );
};
